export default __webpack_public_path__ + "static/media/ac-brand-tech2.35f548ae.jpg";